export const PAGE_PATH = '/';
